module.exports = __webpack_public_path__ + "static/media/apptitude-logo-new-mobile.050ace26.svg";